import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";

import { connect } from "react-redux";

import { tailgateService } from "services";
import { Alert } from "antd";
import { dateFormat } from "utils";

export const TailgateReminder = (props) => {
  const { user, location } = props;
  const [tailgates, setTailgates] = useState([]);

  useEffect(() => {
    const fetchTailgates = async () => {
      const pendingTailgates = await tailgateService.list({ user_id: user.id, published: 0 });
      setTailgates(pendingTailgates);
    };

    fetchTailgates();
  }, [user.id, location.pathname]);

  if (tailgates.length === 0) return <></>;

  return (
    <Alert
      className="tailgate-reminder"
      type="warning"
      showIcon
      message="Vous avez des tailgates en attente de publication"
      description={tailgates.map((tailgate) => (
        <Link key={tailgate.id} to={`/tailgates/${tailgate.id}/edit`}>
          <span className="date">({moment(tailgate.date).format(dateFormat)})</span>
          <span>
            {tailgate.code} : {tailgate.project.label}
          </span>
        </Link>
      ))}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.infos || {},
  };
};

export default connect(mapStateToProps, null)(withRouter(TailgateReminder));
